import { select } from 'core/middlewares/utilities';
import { OldHistory } from 'ui/components/History';

import type { RootState } from 'core/store';

export function* redirectEmptyRecommendation() {
  const catalog: RootState['catalog'] = yield select((rootState: RootState) => rootState.catalog);

  const isRecommendation = catalog.queryOptions.tag === 'recommendation';

  if (!isRecommendation) {
    return;
  }

  if (isRecommendation && catalog.data.length === 0) {
    yield OldHistory.navigate('/recomendacao-indisponivel');
  }
}
